/**
 * 设置 Meta 标签信息
 * Created by Joncky 2024.02
 */

import Vue from 'vue'
import './types/meta-info-interface'

/**
 * 设置标题
*/
const title = function (val) {
  window.document.title = val;
}

/**
 * 设置Meta关键词
 * @param {String} val
 * @returns {String}
 */
const keywords = function (val: string) {
  const meta = window.document.createElement('meta');
  meta.setAttribute('name', 'keywords');
  meta.setAttribute('content', val)
  document.head.appendChild(meta);
}

const description = function (val: string) {
  const meta = window.document.createElement('meta');
  meta.setAttribute('name', 'description');
  meta.setAttribute('content', val)
  document.head.appendChild(meta);
}

const meta = function (metaInfo: MetaInfo) {
  if (metaInfo.title) {
    title(metaInfo.title);
  }

  if (metaInfo.description) {
    description(metaInfo.description);
  }

  if (metaInfo.keywords) {
    keywords(metaInfo.keywords);
  }
}

const install = {
  install: (Vue: any, options: any) => {
    Vue.prototype.$title = title;
    Vue.prototype.$keywords = keywords;
    Vue.prototype.$description = description;
    Vue.prototype.$meta = meta;
  }
}

export default install